import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  IOCRInfoInitialState,
  IUpdateFormStatePayload,
} from '../types/ocr.types'

const initialState: IOCRInfoInitialState = {
  templateLayout: null,
  formState: null,
  fieldMetaState: null,
}

const OCRSlice = createSlice({
  name: 'ocrState',
  initialState,
  reducers: {
    updateTemplateLayout: (state, action) => {
      state.templateLayout = action.payload
    },
    updateFormState: (
      state,
      action: PayloadAction<IUpdateFormStatePayload>
    ) => {
      if (!state.formState) {
        state.formState = {}
      }
      state.formState[action.payload.pageKey] = action.payload.pageData
    },
    clearFormState: (state) => {
      state.formState = null
      state.templateLayout = null
      state.fieldMetaState = null
    },
    updateFieldMetaState: (state, action) => {
      state.fieldMetaState = action.payload
    },
    clearFieldApiValidation: (state, action: PayloadAction<string>) => {
      const fieldKey = action.payload
      const fieldMeta = state.fieldMetaState?.[fieldKey]
      if (!fieldMeta) return
      fieldMeta.is_valid = true
      fieldMeta.validation_message = ''
      fieldMeta.validated = true
    },
  },
})

export const {
  updateTemplateLayout,
  updateFormState,
  clearFormState,
  updateFieldMetaState,
  clearFieldApiValidation,
} = OCRSlice.actions
export default OCRSlice.reducer
